import * as React from 'react'
import { MediaGallery } from './MediaGallery'
import { withS3Url } from '../../file/withS3Url'
import type { CommonDeps } from '../../base/CommonDeps'
import type { ExtensibleFilesValue, PhotoUrls } from '../../../../shared/domain/reports/types.no-deps'
import { VideoAnswer } from './VideoAnswer'
import { assertExhaustion } from '../../../../shared/lib/typeHelpers.no-deps'
import { PhotoAnswer } from './PhotoAnswer'

interface Props {
    deps: CommonDeps
    answerValue: ExtensibleFilesValue
    photoUrls: PhotoUrls
    allowZoom?: boolean
}

export class ExtensibleFileAnswer extends React.Component<Props> {
    public render = () => {
        return (
            <MediaGallery>
                {this.props.answerValue.value.map((file) => {
                    switch (file.type) {
                        case 'PhotoFile':
                            return (
                                <PhotoAnswer
                                    key={file.photo}
                                    deps={this.props.deps}
                                    photoFile={file}
                                    photoUrls={this.props.photoUrls}
                                    allowZoom={this.props.allowZoom}
                                />
                            )
                        case 'VideoFile':
                            return withS3Url(
                                this.props.deps,
                                this.props.photoUrls[file.video],
                                ({ thumbnailS3Url, fullSizeS3Url }) => {
                                    return <VideoAnswer thumnailUrl={thumbnailS3Url} videoUrl={fullSizeS3Url} />
                                }
                            )
                        default:
                            assertExhaustion(file)
                    }
                })}
            </MediaGallery>
        )
    }
}
